export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Division',
          excludeFromVerbatims: true,
          code: 'division',
          multi: true,
          options: [
            // {
            //   label: 'Total',
            //   value: 1,
            //   selected: false
            // },
            {
              label: 'Central',
              value: 1,
              selected: false
            },
            {
              label: 'Northeast',
              value: 2,
              selected: false
            },
            {
              label: 'West',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Segment',
          code: 'segment',
          multi: true,
          options: [
            {
              label: 'Traditionals',
              value: 1,
              selected: false
            },
            {
              label: 'Premiums',
              value: 2,
              selected: false
            },
            {
              label: 'Flexibles',
              value: 3,
              selected: false
            },
            {
              label: 'Utilitarians',
              value: 4,
              selected: false
            },
            {
              label: 'Techies',
              value: 5,
              selected: false
            }
          ]
        },
        {
          label: 'Income',
          excludeFromVerbatims: true,
          code: 'income',
          multi: true,
          options: [
            {
              label: '<$50k',
              value: 1,
              selected: false
            },
            {
              label: '$50k-<$75k',
              value: 2,
              selected: false
            },
            {
              label: '$75k-<$100k',
              value: 3,
              selected: false
            },
            {
              label: '$100k-<$125k',
              value: 4,
              selected: false
            },
            {
              label: '$125k+',
              value: 5,
              selected: false
            }
          ]
        },
        {
          label: 'Kids in HH',
          code: 'children',
          multi: true,
          options: [
            {
              label: 'Yes',
              value: 1,
              selected: false
            },
            {
              label: 'No',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Residence',
          code: 'residence',
          multi: true,
          options: [
            {
              label: 'SFU',
              value: 1,
              selected: false
            },
            {
              label: 'MDU',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Customer/Prospect',
          code: 'customer',
          multi: true,
          options: [
            {
              label: 'Xfinity Customer',
              value: 1,
              selected: false
            },
            {
              label: 'Xfinity Prospect',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Gamers',
          code: 'gamer',
          multi: true,
          options: [
            {
              label: 'Non-Gamer',
              value: 1,
              selected: false
            },
            {
              label: 'Casual Gamer',
              value: 2,
              selected: false
            },
            {
              label: 'Enthusiast Gamer',
              value: 3,
              selected: false
            },
            {
              label: 'Hardcore Gamer',
              value: 4,
              selected: false
            }
          ]
        },
        {
          label: 'Likely Internet Switcher',
          code: 'switcher',
          multi: true,
          options: [
            {
              label: 'Yes',
              value: 1,
              selected: false
            },
            {
              label: 'No',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Movers',
          code: 'mover',
          multi: true,
          options: [
            {
              label: 'Yes, I plan to move in the next 6 months',
              value: 1,
              selected: false
            },
            {
              label: 'Yes, I plan to move in the next 7-12 months',
              value: 2,
              selected: false
            },
            {
              label: 'No, I have no plans to move in the next 12 months',
              value: 3,
              selected: false
            },
            {
              label: 'Prefer not to say',
              value: 4,
              selected: false
            }
          ]
        },
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/scorecard/ScorecardView/ScorecardFilter/index.js